<template>
    <div class="table_wrap">
        <div class="c_table_wrap table_search_wrap">
            <table>
                <colgroup>
                    <col width="200px;">
                    <col width="">
                </colgroup>
                <tr>
                    <td class="c_t_title">언어</td>
                    <td>
                        <div>
                            <el-select v-model="filterCountry" placeholder="언어선택" class="table_s_select" @change="runFilter('cid', filterCountry)">
                                <el-option
                                        :label="'전체'"
                                        :value="''"
                                ></el-option>
                                <el-option
                                        v-for="country in countries"
                                        :key="`country${country.c_idx}`"
                                        :label="country.lang_name_kr"
                                        :value="`${country.c_idx}`"
                                ></el-option>
                            </el-select>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import configUtil from "@/components/config/configUtil"
    import {mapState, mapGetters} from "vuex"
    const {filterConfig} = configUtil;
    export default {
        name: "ConfigFilterDefaultLayout",
        mixins: [],
        components: {
        },
        props:{
            filterData: {},
            setFilter: {
                type: Function,
                default: () => {}
            }
        },
        data() {
            return {
                searchInput: '',
                searchInputOption: 'cid',
                searchInputOptions: [
                    {value: 'cid', label: '국가'},
                ],
                filterCountry: '',
                filterDate: ['', ''],
            }
        },
        beforeRouterEnter() {},
        created() {
        },
        mounted() {
            this.setterFilterDataInData();
        },
        beforeDestroy() {
        },
        destroyed() {},
        computed: {
            ...mapState({
                countries: state => state.country.countries
            })
        },
        methods:{
            setterFilterDataInData() {
                let classnames = Object.keys(this.filterData);
                classnames.forEach(classname => {
                    let obj = this.filterData[classname];
                    let type = filterConfig[obj.key].type;
                    if(this.hasOwnProperty(classname)) {
                        if(type == 'query') {
                            this[classname] = obj.query;
                        }else if(type === 'between') {
                            this[classname] = [obj.start, obj.end];
                        }else if(type === 'match') {
                            this[classname] = obj.value;
                        }
                        if(this.hasOwnProperty(`${classname}Option`)) {
                            this[`${classname}Option`] = obj.key;
                        }
                    }
                })
            },
            setData(key, value) {
                this[key] = value;
            },
            runFilter(key, value) {
                this.setFilter(key, value)
            }
        },
        watch: {

        },
    }
</script>

<style scoped>

</style>